module.exports = ".panel-group {\n  display: block;\n  margin-top: 5px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/maintenance/maintenance.component.scss
// module id = ./src/app/admin/maintenance/maintenance.component.scss
// module chunks = main